// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v5.5.1-jSoAt0XH0RmA5q5lMsh2/mode=imports,min/optimized/keen-slider.js'

class PushcartUpsells extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.onCartChanged,
    )
  }

  onCartChanged (e) {
    // set the id to the target element, or create an div element and  it to the document where you need it to be displayed
    // DO NOT use the same class "klevu-recs" as this might lead to the element having 2 recs objects initialised to it is some scenarios
    // eslint-disable-next-line no-undef
    const element = klevu.dom.getFirst('.klevu-recs-pushcartupsell')
    const id = element.id
    // eslint-disable-next-line no-undef
    const apiKey = klevu.getObjectPath(klevu.settings, 'recs.apiKey')
    // create the recs object for that recommandation instance, this creates a object but does not start the loading of the settings or the loading of the content
    // eslint-disable-next-line no-undef
    const recsBox = klevu.recs.clone({
      recId: id, // the id
      apiKey, // this is your api klevu key
      element, // element needs to be the element created/initialised above with the id
    })

    recsBox.powerUp()

    // show/hide depending on item count
    const { state } = e.detail
    if (!state || !state?.sections) return
    if (!('push-cart-count' in state.sections)) return

    /* eslint-disable no-undef */
    const CartUpsellSection = klevu.dom.find('.psh-CartUpsell')
    const CartUpsellSectionDrawer = klevu.dom.getFirst('.drw-Drawer_Upsell')
    /* eslint-enable */
    const itemCount = this.getCount(state.sections['push-cart-count'])

    CartUpsellSection.forEach(section => {
      section.setAttribute(`aria-hidden`, parseInt(itemCount, 10) < 1)
    })
    CartUpsellSectionDrawer.setAttribute(
      `aria-hidden`,
      parseInt(itemCount, 10) < 1,
    )
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}
if (!customElements.get('pushcart-upsells')) {
  customElements.define('pushcart-upsells', PushcartUpsells)
}

class PushcartCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    const barWidth = 240 / this.els.slide.elements.length
    this.els.progress.element.style.setProperty('--bar-width', `${barWidth}%`)

    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.triggerMouseUpEvent = this.triggerMouseUpEvent.bind(this)
    this.listeners.add(this, 'contextmenu', this.triggerMouseUpEvent)
    this.listeners.add(this, 'mousedown', event => {
      const selectEl = event.target.closest(`select`)
      if (!selectEl) return
      this.triggerMouseUpEvent(event)
    })
  }

  triggerMouseUpEvent (event) {
    const mouseUpEvent = new MouseEvent('mouseup', { bubbles: true })
    event.target.dispatchEvent(mouseUpEvent)
  }

  initialiseCarousel () {
    return new KeenSlider(this.els.slides.element, {
      duration: 1000,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slidesPerView: 2.4,
      spacing: 20,
      slides: '.car-Carousel_Slide',
      move: instance => {
        if (this.els.progress.element) {
          const progressTrack = instance.details().progressTrack
          const progressAmount = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressAmount * 100
          this.els.progress.element.style.setProperty(
            '--progress',
            `${movementPercentage}%`,
          )
        }
      },
      slideChanged: instance => {
        if (this.els.next.element) {
          const currentSlide = instance.details().absoluteSlide
          const slidesPerView = instance.details().slidesPerView
          const carouselSize = instance.details().size

          currentSlide === 0
            ? this.els.previous.element.setAttribute('disabled', null)
            : this.els.previous.element.removeAttribute('disabled')

          currentSlide + slidesPerView >= carouselSize
            ? this.els.next.element.setAttribute('disabled', null)
            : this.els.next.element.removeAttribute('disabled')
        }
      },
      created: instance => {
        if (this.nextEl) {
          this.nextEl.addEventListener('click', () => {
            instance.next()
          })
        }

        if (this.previousEl) {
          this.previousEl.addEventListener('click', () => {
            instance.prev()
          })
        }
      },
    })
  }

  get nextEl () {
    return this.els.next && this.els.next.element ? this.els.next.element : null
  }

  get previousEl () {
    return this.els.previous && this.els.previous.element
      ? this.els.previous.element
      : null
  }
}

if (!customElements.get('pushcart-carousel')) {
  customElements.define('pushcart-carousel', PushcartCarousel)
}
